import * as React from "react";
const SvgFiRrNotFoundAlt = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-not-found-alt_svg__a)">
      <path
        fill="#062147"
        d="m23.707 22.293-5.963-5.963a9.95 9.95 0 0 0 2.262-6.324c0-5.514-4.486-10-10-10s-10 4.486-10 10 4.486 10 10 10c2.398 0 4.6-.85 6.324-2.262l5.963 5.963a.997.997 0 0 0 1.414 0 1 1 0 0 0 0-1.414m-13.7-4.287c-4.412 0-8-3.589-8-8s3.588-8 8-8c4.41 0 8 3.59 8 8s-3.59 8-8 8m3.7-10.299L11.414 10l2.293 2.293a.999.999 0 1 1-1.414 1.414L10 11.414l-2.293 2.293a.997.997 0 0 1-1.414 0 1 1 0 0 1 0-1.414L8.586 10 6.293 7.707a.999.999 0 1 1 1.414-1.414L10 8.586l2.293-2.293a.999.999 0 1 1 1.414 1.414"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-not-found-alt_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrNotFoundAlt;
